import { Validator } from '@vista-digital/validator';
export const defaultOrderTipConfig = {
    isEnabled: false,
    includeSundryItems: false
};
export const orderTipConfigValidator = Validator.object({
    isEnabled: Validator.boolean(),
    includeSundryItems: Validator.boolean()
});
//# sourceMappingURL=tip.js.map